import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchTrainingProgramsState } from "../../../interfaces/store/training-programs-interface";
import { PAGE_SIZE } from "../../../common/config";

const initialState: IFetchTrainingProgramsState = {
  trainingPrograms: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchTrainingProgramsStart = (
  state: IFetchTrainingProgramsState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchTrainingProgramsSuccess = (
  state: IFetchTrainingProgramsState,
  { payload }: PayloadAction<any>
) => {
  state.trainingPrograms = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchTrainingProgramsFailed = (
  state: IFetchTrainingProgramsState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetTrainingPrograms = () => {
  return { ...initialState };
};

const TrainingProgramsSlice = createSlice({
  name: "trainingPrograms",
  initialState,
  reducers: {
    fetchTrainingProgramsStart: _fetchTrainingProgramsStart,
    fetchTrainingProgramsSuccess: _fetchTrainingProgramsSuccess,
    fetchTrainingProgramsFailed: _fetchTrainingProgramsFailed,
    resetTrainingPrograms: _resetTrainingPrograms,
  },
});

export const {
  fetchTrainingProgramsStart,
  fetchTrainingProgramsSuccess,
  fetchTrainingProgramsFailed,
  resetTrainingPrograms,
} = TrainingProgramsSlice.actions;
export default TrainingProgramsSlice.reducer;
